import * as React from 'react';
import { Grid, Card, CircularProgress, Typography, Box } from '@mui/material';
import { uniqueId } from 'lodash';
import { makeImgUrl, makeVideoUrl } from 'features/api_url';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { productRemovedPhoto, removeVideoFromProduct } from 'features/products/productsSlice';
import { useDispatch } from 'react-redux';
import { videoDeleted } from 'features/videos/videosSlice';
import { useSnackbar } from 'notistack';
const ProductPhotosList = (props) => {

    const { product } = props;
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const onPhotoDelete = (photoInfo) => {

        console.log(photoInfo);
        dispatch(productRemovedPhoto(photoInfo));

    }
    const onVideoDelete = async (videoInfo) => {

        console.log('onVideoDelete ',videoInfo);
        dispatch(videoDeleted(videoInfo))
            .then(function(response){
                if(response.type == "videos/videoDeleted/fulfilled"){

                    console.log('Video removed from product');
                    dispatch(removeVideoFromProduct(videoInfo));
                    enqueueSnackbar('Video removed successfully');
                } else {
                    enqueueSnackbar('Error - ' + response.error.message);
                    console.log('Error - ', response.error.message);
                }

            });

    }
    return(
        <>
        { !product && <CircularProgress />}
        { product &&
        <>
        <Typography variant="h4" sx={{mb:2}}>Product images</Typography>
        <Grid
            container
            spacing={3}
        >
            { product.images.map((photo,index) => {
                return(
                    <Grid
                        item
                        xs={6}
                        sm={4}
                        md={3}
                        lg={2}
                        key={uniqueId()}
                    >
                        <Card sx={{ backgroundColor:"#f2f2f2",height:"100px;", position:"relative"}}>
                            <img src={makeImgUrl(product.id,"320",photo.url)} alt={photo.title} width="100%"/>
                            <IconButton
                                aria-label="delete" 
                                sx={{position:"absolute",top:"5px",right:"5px",color:"white"}}
                                onClick={() => onPhotoDelete({ photoId: photo.id, productId: product.id})}>
                                    <DeleteIcon />
                            </IconButton>
                        </Card>
                    </Grid>
                    )
                })}
        </Grid>
        <Box sx={{mt:4}}>
            { product.images.length == 0 && <Typography variant="pgreen">Uploaded images will be shown here</Typography>}
        </Box>
        <Typography variant="h4" sx={{mb:2}}>Product videos</Typography>
        <Grid
            container
            spacing={3}
        >
            { product.videos.map((video,index) => {
                return(
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        key={uniqueId()}
                    >
                        <Card sx={{ backgroundColor:"#f2f2f2", position:"relative"}}>
                            <video width="100%" src={makeVideoUrl(video.url)} controls />
                            
                            <IconButton
                                aria-label="delete" 
                                sx={{position:"absolute",top:"5px",right:"5px",color:"white"}}
                                onClick={() => onVideoDelete({ videoId: video.id, productId: product.id})}>
                                    <DeleteIcon />
                            </IconButton>
                        </Card>
                    </Grid>
                    )
                })}
        </Grid>
        <Box sx={{mt:4}}>
            { product.videos.length == 0 && <Typography variant="pgreen">Uploaded videos will be shown here</Typography>}
        </Box>
        </>
        }
        </>
    )
}

export default ProductPhotosList;